export const types = {
  SET_STATE: 'SET_STATE',
  SET_DELIVERY_DATE: 'SET_DELIVERY_DATE',
  SET_CHARGE_DATE: 'SET_CHARGE_DATE',
  SET_ORDER_COMMENT: 'SET_ORDER_COMMENT',
  SET_ADDITIONAL_FV_INFO: 'SET_ADDITIONAL_FV_INFO',
  SET_DISTRIBUTION: 'SET_DISTRIBUTION',
  HYDRATE: 'HYDRATE',
  RESET_DANGEROUS_FIELDS: 'RESET_DANGEROUS_FIELDS',
};
